import React, { useImperativeHandle, useRef, forwardRef, useState, useEffect } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import backendToInputDate from "../../../utils/backendToInputDate";
import { RequiredLabel } from "../../../components/RequiredLabel/RequiredLabel";
// import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import api from "../../../api/Api";

const EmployeeForm = forwardRef(({ onSubmit, initialData = {} }, ref) => {
  const formikRef = useRef(null);
  const [managers, setManagers] = useState([]);
  const [locations, setLocations] = useState([]);
  const [shifts, setShifts] = useState([]);

  useEffect(() => {
  api
    .get("/api/employees/location")
    .then(res => {
      console.log("API response:", res);

      if (res?.data?.status) {
        setLocations(res.data.response || []);
      }
    })
    .catch(err => {
      console.error("Failed to fetch locations", err);
    });
}, []);

 useEffect(() => {
  api
    .get("/api/employees/shift")
    .then(res => {

      if (res?.data?.status) {
        setShifts(res.data.response || []);
      }
    })
    .catch(err => {
      console.error("Failed to fetch shifts", err);
    });
}, []);

useEffect(() => {
  api
    .get("/api/auth/managers")
    .then(res => {

      if (res?.data?.status) {
        setManagers(res.data.response || []);
        console.log(managers);
        
      }
    })
    .catch(err => {
      console.error("Failed to fetch shifts", err);
    });
}, []);



  const initialValues = {
    name: initialData.name || "",
    employeeId: initialData.employeeId || "",
    email: initialData.email || "",
    mobileNo: initialData.mobileNo || "",
    designation: initialData.designation || "",
    dateOfJoining: backendToInputDate(initialData.dateOfJoining) || "",
    reportingManager: initialData.reportingManager || "",
    location: initialData.location || "",
    shift: initialData.shift || "",
    address: initialData.address || "",
    gender: initialData.gender || "",
    dateOfBirth: backendToInputDate(initialData.dateOfBirth) || "",
  };

  const validationSchema = Yup.object({
    name: Yup.string()
      .matches(/^[A-Za-z ]{2,20}$/, "Only letters and spaces allowed (2-20)")
      .required("Employee Name is required"),
    employeeId: Yup.string()
      .matches(/^(IS)[0-9]{3,5}$/, "Employee ID must start with IS followed by 3-5 digits")
      .required("Employee ID is required"),
    email: Yup.string().email("Invalid Email format").required("Email is required"),
    mobileNo: Yup.string()
      .matches(/^[6-9][0-9]{9}$/, "Mobile Number must be 10 digits starting with 6-9")
      .required("Mobile Number is required"),
    designation: Yup.string().required("Designation is required"),
    dateOfJoining: Yup.string()
      .matches(/^\d{4}-\d{2}-\d{2}$/, "Invalid date")
      .required("Date of Joining is required"),
    reportingManager:  Yup.string().required("Reporting Manager is required"),
    location: Yup.string().required("Location is required"),
    shift: Yup.string().required("Shift is required"),
    address: Yup.string().required("Address is required"),
    gender: Yup.string().required("Gender is required"),
    dateOfBirth: Yup.string()
      .matches(/^\d{4}-\d{2}-\d{2}$/, "Invalid date")
      .required("Date of Birth is required"),
  });

  useImperativeHandle(ref, () => ({
    submitForm: async () => {
      if (!formikRef.current) return;
      const errors = await formikRef.current.validateForm();
      if (Object.keys(errors).length) {
        const firstKey = Object.keys(errors)[0];
        // toast.error(errors[firstKey]);
        // mark the first field (and any others) as touched so UI shows the errors
        formikRef.current.setTouched(
          Object.keys(initialValues).reduce((acc, k) => {
            acc[k] = !!errors[k];
            return acc;
          }, {})
        );
        return;
      }
      // all good — let Formik run its submit flow
      formikRef.current.submitForm();
    },
  }));

  return (
    <div>
      {/* <ToastContainer /> */}
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values, { setSubmitting }) => {
          onSubmit(values);
          setSubmitting(false);
        }}
        innerRef={formikRef}
      >
        {formik => (
          <Form onSubmit={formik.handleSubmit} className="p-4 border rounded container bg-white my-4" noValidate>
            <div className="row">
              <div className="col-md-6 mb-3">
                <RequiredLabel label="Name" htmlFor="name" />
                <input
                  type="text"
                  id="name"
                  name="name"
                  className={`form-control ${formik.touched.name && formik.errors.name ? "is-invalid" : ""}`}
                  maxLength={20}
                  {...formik.getFieldProps("name")}
                />
                {formik.touched.name && formik.errors.name && (
                  <div className="invalid-feedback">{formik.errors.name}</div>
                )}
              </div>

              <div className="col-md-6 mb-3">
                <RequiredLabel label="Employee ID (IS001)" htmlFor="employeeId" />
                <input
                  type="text"
                  id="employeeId"
                  name="employeeId"
                  className={`form-control ${formik.touched.employeeId && formik.errors.employeeId ? "is-invalid" : ""}`}
                  {...formik.getFieldProps("employeeId")}
                />
                {formik.touched.employeeId && formik.errors.employeeId && (
                  <div className="invalid-feedback">{formik.errors.employeeId}</div>
                )}
              </div>
            </div>

            <div className="row">
              <div className="col-md-6 mb-3">
                <RequiredLabel label="Email" htmlFor="email" />
                <input
                  type="email"
                  id="email"
                  name="email"
                  className={`form-control ${formik.touched.email && formik.errors.email ? "is-invalid" : ""}`}
                  {...formik.getFieldProps("email")}
                />
                {formik.touched.email && formik.errors.email && (
                  <div className="invalid-feedback">{formik.errors.email}</div>
                )}
              </div>

              <div className="col-md-6 mb-3">
                <RequiredLabel label="Mobile No" htmlFor="mobileNo" />
                <input
                  type="tel"
                  id="mobileNo"
                  name="mobileNo"
                  className={`form-control ${formik.touched.mobileNo && formik.errors.mobileNo ? "is-invalid" : ""}`}
                  maxLength={10}
                  {...formik.getFieldProps("mobileNo")}
                />
                {formik.touched.mobileNo && formik.errors.mobileNo && (
                  <div className="invalid-feedback">{formik.errors.mobileNo}</div>
                )}
              </div>
            </div>

            <div className="row">
              <div className="col-md-6 mb-3">
                <RequiredLabel label="Designation" htmlFor="designation" />
                <input
                  type="text"
                  id="designation"
                  name="designation"
                  className={`form-control ${formik.touched.designation && formik.errors.designation ? "is-invalid" : ""}`}
                  {...formik.getFieldProps("designation")}
                />
                {formik.touched.designation && formik.errors.designation && (
                  <div className="invalid-feedback">{formik.errors.designation}</div>
                )}
              </div>

              <div className="col-md-6 mb-3">
                <RequiredLabel label="Date of Joining" htmlFor="dateOfJoining" />
                <input
                  type="date"
                  id="dateOfJoining"
                  name="dateOfJoining"
                  className={`form-control ${formik.touched.dateOfJoining && formik.errors.dateOfJoining ? "is-invalid" : ""}`}
                  {...formik.getFieldProps("dateOfJoining")}
                />
                {formik.touched.dateOfJoining && formik.errors.dateOfJoining && (
                  <div className="invalid-feedback">{formik.errors.dateOfJoining}</div>
                )}
              </div>
            </div>

            <div className="row">
             <div className="col-md-4 mb-3">
                <RequiredLabel label="Reporting Manager" htmlFor="reportingManager" />

                <select
                  id="reportingManager"
                  name="reportingManager"
                  className={`form-select ${
                    formik.touched.reportingManager && formik.errors.reportingManager
                      ? "is-invalid"
                      : ""
                  }`}
                  {...formik.getFieldProps("reportingManager")}
                >
                  <option value="">--- Select Manager ---</option>

                  {managers.map(manager => (
                    <option key={manager.username} value={manager.username}>
                      {manager.username}
                    </option>
                  ))}
                </select>

                {formik.touched.reportingManager && formik.errors.reportingManager && (
                  <div className="invalid-feedback">
                    {formik.errors.reportingManager}
                  </div>
                )}
              </div>


              <div className="col-md-4 mb-3">
              <RequiredLabel label="Location" htmlFor="location" />
              <select
                id="location"
                name="location"
                className={`form-select ${formik.touched.location && formik.errors.location ? "is-invalid" : ""}`}
                {...formik.getFieldProps("location")}
              >
                <option value="">--- Select Location ---</option>
                {locations.map(loc => (
                  <option
                    key={loc.locationIdnty}
                    value={loc.locationName} 
                  >
                    {loc.locationName}
                  </option>
                ))}
              </select>
              <div className="invalid-feedback">{formik.errors.location}</div>
            </div>

                <div className="col-md-4 mb-3">
              <RequiredLabel label="Shift" htmlFor="shift" />
              <select
                id="shift"
                name="shift"
                className={`form-select ${
                  formik.touched.shift && formik.errors.shift ? "is-invalid" : ""
                }`}
                {...formik.getFieldProps("shift")}
              >
                <option value="">--- Select Shift ---</option>

                {shifts.map(shift => (
                  <option key={shift} value={shift}>
                    {shift}
                  </option>
                ))}
              </select>

              {formik.touched.shift && formik.errors.shift && (
                <div className="invalid-feedback">{formik.errors.shift}</div>
              )}
            </div>
            </div>

            <div className="mb-3">
              <RequiredLabel label="Address" htmlFor="address" />
              <input
                type="text"
                id="address"
                name="address"
                className={`form-control ${formik.touched.address && formik.errors.address ? "is-invalid" : ""}`}
                {...formik.getFieldProps("address")}
              />
              {formik.touched.address && formik.errors.address && (
                <div className="invalid-feedback">{formik.errors.address}</div>
              )}
            </div>

            <div className="row">
              <div className="col-md-6 mb-3">
                <RequiredLabel label="Gender" htmlFor="gender" />
                <select
                  id="gender"
                  name="gender"
                  className={`form-select ${formik.touched.gender && formik.errors.gender ? "is-invalid" : ""}`}
                  {...formik.getFieldProps("gender")}
                >
                  <option value="">--- Select Gender ---</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
                {formik.touched.gender && formik.errors.gender && (
                  <div className="invalid-feedback">{formik.errors.gender}</div>
                )}
              </div>

              <div className="col-md-6 mb-3">
                <RequiredLabel label="Date of Birth" htmlFor="dateOfBirth" />
                <input
                  type="date"
                  id="dateOfBirth"
                  name="dateOfBirth"
                  className={`form-control ${formik.touched.dateOfBirth && formik.errors.dateOfBirth ? "is-invalid" : ""}`}
                  {...formik.getFieldProps("dateOfBirth")}
                />
                {formik.touched.dateOfBirth && formik.errors.dateOfBirth && (
                  <div className="invalid-feedback">{formik.errors.dateOfBirth}</div>
                )}
              </div>
            </div>

            {/* submit button intentionally omitted; parent should call ref.submitForm() */}
          </Form>
        )}
      </Formik>
    </div>
  );
});

export default EmployeeForm;
